import { GeojsonLayer, Layer, LightningLayer, MapboxLayerState, WXTilesLayer, WXTilesV3Layer } from '@mono/types/src/platmap';

type WXTilesV3LayerType = Layer & { state: WXTilesV3Layer };
type LightningLayerType = Layer & { state: LightningLayer };
type GeojsonLayerType = Layer & { state: GeojsonLayer };
type WXTilesLayerType = Layer & { state: WXTilesLayer };
type MapboxLayerStateType = Layer & { state: MapboxLayerState };

export const isWXTilesV3Layer = (layer: Layer): layer is WXTilesV3LayerType => layer.state.type === 'wxtilesv3';
export const isLightningLayer = (layer: Layer): layer is LightningLayerType => layer.state.type === 'lightning';
export const isGeojsonLayer = (layer: Layer): layer is GeojsonLayerType => layer.state.type === 'geojson';
export const isWXTilesLayer = (layer: Layer): layer is WXTilesLayerType => layer.state.type === 'wxtiles';
export const isMapboxLayer = (layer: Layer): layer is MapboxLayerStateType => layer.state.type === 'mapbox';
